import React, { lazy, Suspense } from "react";

const RemoteChangeServiceTariffHistory = lazy(
  () => import("@/changeservice/components/ChangeServiceTariffHistory/ChangeServiceTariffHistory")
);

const ChangeServiceTariffHistory = (props: Remote.ChangeServiceTariffHistory) => {
  return (
    <Suspense fallback={<></>}>
      <RemoteChangeServiceTariffHistory {...props} />
    </Suspense>
  );
};

export default ChangeServiceTariffHistory;
